import { Heading, Text } from "@cognigy-internal/ui-component-library";
import arrowRight from "../assets/icon-arrow-right.svg";
import dollar from "../assets/icon-dollar.svg";
import doorOpen from "../assets/icon-door-open.svg";
import keyRound from "../assets/icon-key-round.svg";

const BENEFITS = [
	{
		icon: keyRound,
		title: "Full platform access",
		body: "Try every feature, from design to deployment.",
	},
	{
		icon: doorOpen,
		title: "Fast onboarding",
		body: "Beginner or expert, get hands-on in minutes with intuitive, AI-assisted guidance.",
	},
	{
		icon: dollar,
		title: "No cost, no subscription",
		body: "Free to try, with no credit card, download or plugin needed.",
	},
] as const;

export function Benefits() {
	return (
		<ul className="mt-8 flex flex-col gap-2">
			{BENEFITS.map(({ icon, title, body }) => (
				<li
					key={title}
					className="flex items-start gap-2 rounded-lg bg-white/60 p-4"
				>
					<img
						src={icon}
						alt=""
						width={24}
						height={24}
						className="shrink-0"
					/>
					<div className="flex min-w-0 flex-1 flex-col gap-1">
						<Heading
							as="h2"
							variant="h4"
							className="text-primary-500 text-sm leading-5 font-bold"
						>
							{title}
						</Heading>
						<Text
							variant="body"
							className="text-sm leading-5 font-medium"
						>
							{body}
						</Text>
					</div>
				</li>
			))}
		</ul>
	);
}

// Destination for the demo card; confirm with the web team.
const DEMO = {
	title: "Prefer a demo of our AI Agents?",
	body: "Talk to one of our experts and start your journey to customer service loved by everyone",
	cta: "See a demo",
	href: "https://www.cognigy.com/demo",
} as const;

export function DemoCard() {
	return (
		<section
			aria-label="Book a demo"
			className="mx-auto w-full max-w-[65.25rem] px-6 py-16 md:px-8"
		>
			<div className="border-border flex flex-col gap-4 rounded-2xl border bg-white p-6 sm:flex-row sm:items-center sm:justify-between">
				<div className="flex flex-col gap-2">
					<Heading
						as="h2"
						variant="h4"
						className="text-base font-normal"
					>
						{DEMO.title}
					</Heading>
					<Text
						variant="body"
						className="text-muted-foreground text-sm leading-5"
					>
						{DEMO.body}
					</Text>
				</div>
				<a
					href={DEMO.href}
					className="text-primary-500 focus-visible:ring-primary-300 flex w-fit shrink-0 items-center gap-2 rounded-sm px-4 text-sm whitespace-nowrap outline-none hover:underline focus-visible:ring-2"
				>
					{DEMO.cta}
					<img
						src={arrowRight}
						alt=""
						width={16}
						height={16}
					/>
				</a>
			</div>
		</section>
	);
}

const FOOTER_LINKS = [
	{ href: "https://www.cognigy.com/privacy-policy", label: "Privacy Policy" },
	{ href: "https://www.cognigy.com/legal-notice", label: "Legal Notice" },
	{ href: "https://support.cognigy.com/hc", label: "Support" },
	{ href: "https://www.linkedin.com/company/cognigy/", label: "LinkedIn" },
	{ href: "https://github.com/Cognigy", label: "GitHub" },
	{ href: "https://www.youtube.com/channel/UCR2RYQDd-z23CN2iu4LhjKQ", label: "Youtube" },
] as const;

export function Footer() {
	return (
		<footer className="flex flex-col gap-4 px-6 py-6 md:flex-row md:items-center md:justify-between md:gap-8">
			<Text
				variant="body-sm"
				className="text-muted-foreground text-sm"
			>
				© {new Date().getFullYear()} NiCE Cognigy. All rights reserved.
			</Text>
			<nav aria-label="Footer">
				<ul className="flex flex-wrap gap-x-2 gap-y-1">
					{FOOTER_LINKS.map(({ href, label }) => (
						<li key={href}>
							<a
								href={href}
								className="text-primary-900 focus-visible:ring-primary-300 inline-flex h-9 items-center rounded-md px-4 text-sm outline-none hover:underline focus-visible:ring-2"
							>
								{label}
							</a>
						</li>
					))}
				</ul>
			</nav>
		</footer>
	);
}
